import classNames from 'classnames'
import React, { FunctionComponent } from 'react'
import styled from 'styled-components'

const Outer = styled.div`
  position: fixed;
  background-color: var(--pale-beige);
  color: var(--main-text-color);
  top: 0;
  right: 0;
  width: auto;
  height: 100%;
  z-index: 100;
  opacity: 0;
  transition: opacity 0.4s, transform 0.4s;
  pointer-events: none;
  transform: translateX(100%);
  font-family: var(--sans-serif-font);
  &.open {
    pointer-events: all;
    opacity: 1;
    transform: none;
  }
`

const Inner = styled.div`
  padding: 6rem 4rem 1rem 2rem;
  display: flex;
  flex-direction: column;
`

const LinkContainer = styled.div``

const Border = styled.div`
  border-top: 1px solid #CFCFCF;
  margin-block: 0.5rem;
  margin-inline: -1rem;
`

const Head = styled.div`
  font-size: 1rem;
  line-height: 2.5rem;
  letter-spacing: 0.1em;
@media (max-width: 40rem){
  font-size: 1.125rem;
  line-height: 1.5;
  letter-spacing: 0.1em;
}
`

const Item = styled.a`
  font-size: 0.75rem;
  line-height: 2.5rem;
  font-weight: 400;
  display: block;
  transition: opacity 0.4s;
  &:hover {
    opacity: 0.5;
  }
  @media (max-width: 40rem){
    font-size: 0.75rem;
    line-height: 2.5;
    font-weight: 400; 
  }
`

const Navigator = styled.div`
  display: grid;
  grid-template-columns: auto;
  column-gap: 1rem;
`

const NavigatorItem = styled.a`
  padding: 0.5rem 0;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: opacity 0.4s;
  &:hover {
    opacity: 0.5;
  }
  &::after {
    content: '';
    width: 100%;
    height: 1px;
    background-color: white;
    display: block;
    bottom: 0;
    left: 0;
    transform: scaleX(0);
    transform-origin: 100% 100%;
    transition: transform 0.6s;
  }
  &:hover &::after {
    transform: none;
    transform-origin: 0 0;
  }
  @media (max-width: 40rem){
    font-size: 1.375rem;
  }
`

const NavigatorItemLabelEn = styled.div`
  font-size: 0.875rem;
  line-height: 0.9285714285714286;
  letter-spacing: 0.07em;
  font-weight: 400;
  font-family: var(--sans-serif-font);
`

const NavigatorItemLabelJa = styled.div`
  font-size: 0.5625rem;
  line-height: 1.4444444444444444;
  letter-spacing: 0.05em;
  font-weight: 300;
  margin-top: 0.25rem;
  font-weight: 500;
  font-family: var(--sans-serif-font);
`

type MenuProps = {
  open: boolean
}
export const Menu: FunctionComponent<MenuProps> = ({open}) => {
  return <Outer className={classNames({open})}>
    <Inner>

      <Navigator>
        <NavigatorItem href="/products">
          <NavigatorItemLabelEn>PRODUCTS</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>商品一覧</NavigatorItemLabelJa>
        </NavigatorItem>
        <NavigatorItem href="/concept">
          <NavigatorItemLabelEn>ABOUT US</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>Teaflexについて</NavigatorItemLabelJa>
        </NavigatorItem>
        <NavigatorItem href="/feature">
          <NavigatorItemLabelEn>FEATURE</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>お茶の魅力</NavigatorItemLabelJa>
        </NavigatorItem>
        <NavigatorItem href="/news">
          <NavigatorItemLabelEn>NEWS</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>お知らせ</NavigatorItemLabelJa>
        </NavigatorItem>
        {/* hide column */}
        {/* <NavigatorItem href="/column">
          <NavigatorItemLabelEn>COLUM</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>コラム</NavigatorItemLabelJa>
        </NavigatorItem> */}
        <NavigatorItem href="/faq">
          <NavigatorItemLabelEn>FAQ</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>よくあるご質問</NavigatorItemLabelJa>
        </NavigatorItem>
        <NavigatorItem href="https://stoked-store.jp/shop/customer">
          <NavigatorItemLabelEn>My Page</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>マイページ</NavigatorItemLabelJa>
        </NavigatorItem>
        {/* <NavigatorItem href="https://stoked-store.jp/shop/cart">
          <NavigatorItemLabelEn>Cart</NavigatorItemLabelEn>
          <NavigatorItemLabelJa>カート</NavigatorItemLabelJa>
        </NavigatorItem> */}
      </Navigator>
      <LinkContainer>
        <Border />
        <Item href="https://stoked-store.jp/shop/customers/sign_up">新規会員登録</Item>
        <Item href="https://stoked-store.jp/shop/customers/sign_in">ログイン</Item>
        <Border />
        <Item href="/news">お知らせ</Item>
        <Border />
        <Item href="https://stoked-store.jp/shop/base_info">会社概要</Item>
        <Item href="https://stoked-store.jp/shop/customer_term">利用規約</Item>
        <Item href="https://stoked-store.jp/shop/law_info">特定商取引法に基づく表記</Item>
        <Item href="https://stoked-store.jp/shop/privacy">プライバシーポリシー</Item>
        <Border />
        <Item href="https://stoked-store.jp/shop/contact">お問い合わせ</Item>
        <Item href="/faq">よくあるご質問</Item>
      </LinkContainer>
    </Inner>
  </Outer>
}